/*
 * =============================================================================
 * Project: payments.telestrada-online.pl
 * Created Date: 2018-07-17, 09:39:21
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-07-26, 14:58:48
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

// Vuex Payment module actions

import { API } from '@/config';

import {
  FILL_PAYMENT_PARAMS, SET_TOKEN_VALIDATION_STATE,
  FILL_SALES_SERVICE_POINT_DATA, SET_GATEWAY_URL,
  TOGGLE_WAITING_FOR_REDIRECTION_TO_GATEWAY,
  TOGGLE_WAITING_FOR_SALES_SERVICE_POINT_DATA,
  ENABLE_SUBMIT_PAYMENT,
  DISABLE_SUBMIT_PAYMENT,
  SET_SELECTED_GATEWAY, SET_CREDIT_CARD_DATA, SET_LANGUAGE,
} from './mutations-types';

export default {

  async getSaleServicePointSettingsByToken({ commit }, token = '') {
    try {
      const { params, saleServicePoint } = (await API.get(
        `/salesServicesPoints/getSaleServicePointSettingsByToken?token=${token}`)).data.data;
      commit(FILL_PAYMENT_PARAMS, { params });
      commit(FILL_SALES_SERVICE_POINT_DATA, { saleServicePoint });
      commit(SET_TOKEN_VALIDATION_STATE, { isValid: true });
      commit(TOGGLE_WAITING_FOR_SALES_SERVICE_POINT_DATA);
    } catch (err) {
      commit(SET_TOKEN_VALIDATION_STATE, { isValid: false });
      commit(TOGGLE_WAITING_FOR_SALES_SERVICE_POINT_DATA);
    }

    return token;
  },

  async getRedirectUrlForPayment({ commit, state }, { token = '', gatewayUuid = '' }) {
    commit(TOGGLE_WAITING_FOR_REDIRECTION_TO_GATEWAY);
    try {
      const card = state.creditCardData;
      const params = { token, gateway: gatewayUuid, card };
      const gatewayUrl = (await API.post(
        '/salesServicesPoints/getRedirectUrlForPayment', params,
      )).data.data;
      commit(SET_GATEWAY_URL, { gatewayUrl });
    } catch (err) {
      console.error(err);
      commit(TOGGLE_WAITING_FOR_REDIRECTION_TO_GATEWAY);
    }
  },

  setSelectedGateway({ commit }, uuid) {
    commit(SET_SELECTED_GATEWAY, { uuid });
  },

  enableSubmitPayment({ commit }) {
    commit(ENABLE_SUBMIT_PAYMENT);
  },

  disableSubmitPayment({ commit }) {
    commit(DISABLE_SUBMIT_PAYMENT);
  },

  setCreditCard({ commit }, creditCardData) {
    commit(SET_CREDIT_CARD_DATA, creditCardData);
  },

  setLanguage({ commit }, lang) {
    commit(SET_LANGUAGE, { lang });
  },

  changeLoadingState({ commit }, state) {
    commit(TOGGLE_WAITING_FOR_SALES_SERVICE_POINT_DATA, { state });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Payment/actions.js